var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.168 5.427L3.978.237a.81.81 0 00-1.146 0c-.317.317-.285.802 0 1.147l4.633 4.61-4.633 4.622a.81.81 0 001.147 1.147l5.189-5.19a.81.81 0 000-1.146z","fill":"currentColor"}));
}

ChevronInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
